import styled from "styled-components";
import dayjs from "dayjs";
import { MAIN_THEME } from "styles/colors";

interface DateFilterBadgesProps {
	onDateRangeSelect: (dateFrom: string, dateTo: string) => void;
}

const BadgesContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	width: 100%;
`;

const Badge = styled.button`
	padding: 4px 12px;
	border: 1px solid rgba(148, 163, 184, 0.25);
	background: transparent;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	border-radius: 6px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	transition: all 0.15s ease;
	white-space: nowrap;
	line-height: 1.4;

	&:hover {
		border-color: ${MAIN_THEME.SECONDARY};
		background-color: rgba(255, 97, 97, 0.05);
		box-shadow: 0 0 8px rgba(255, 97, 97, 0.1);
	}

	&:active {
		transform: scale(0.98);
	}

	@media (max-width: 768px) {
		padding: 3px 10px;
		font-size: 11px;
	}
`;

const DateFilterBadges = ({ onDateRangeSelect }: DateFilterBadgesProps) => {
	const handleBadgeClick = (rangeType: string) => {
		const today = dayjs();
		let dateFrom: string;
		let dateTo: string;

		switch (rangeType) {
			case "last30days":
				dateFrom = today.subtract(30, "days").toISOString();
				dateTo = today.toISOString();
				break;
			case "lastmonth":
				dateFrom = today
					.subtract(1, "month")
					.startOf("month")
					.toISOString();
				dateTo = today.subtract(1, "month").endOf("month").toISOString();
				break;
			case "ytd":
				dateFrom = today.startOf("year").toISOString();
				dateTo = today.toISOString();
				break;
			case "lastyear":
				dateFrom = today
					.subtract(1, "year")
					.startOf("year")
					.toISOString();
				dateTo = today.subtract(1, "year").endOf("year").toISOString();
				break;
			default:
				return;
		}

		onDateRangeSelect(dateFrom, dateTo);
	};

	const presets = [
		{ label: "Last 30 days", key: "last30days" },
		{ label: "Last month", key: "lastmonth" },
		{ label: "YTD", key: "ytd" },
		{ label: "Last year", key: "lastyear" },
	];

	return (
		<BadgesContainer>
			{presets.map((preset) => (
				<Badge
					key={preset.key}
					onClick={() => handleBadgeClick(preset.key)}
				>
					{preset.label}
				</Badge>
			))}
		</BadgesContainer>
	);
};

export default DateFilterBadges;
